import React, { useEffect, useRef, useState } from "react";
import { Button } from "@/components/ui/button";
import { Play } from "lucide-react";

export function ClickSpeed({ onScore }) {
  const [clicks, setClicks] = useState(0);
  const [time, setTime] = useState(5);
  const [running, setRunning] = useState(false);
  const [over, setOver] = useState(false);
  const reported = useRef(false);

  useEffect(() => {
    if (!running) return;
    if (time <= 0) { setRunning(false); setOver(true); return; }
    const t = setTimeout(() => setTime((x) => x - 1), 1000);
    return () => clearTimeout(t);
  }, [running, time]);

  const start = () => { setClicks(0); setTime(5); setRunning(true); setOver(false); reported.current = false; };
  useEffect(() => { if (over && !reported.current) { reported.current = true; onScore?.(clicks * 30); } }, [over, clicks, onScore]);

  return (
    <div className="flex flex-col items-center" data-testid="click-speed">
      <div className="flex gap-6 mb-4 font-mono">
        <span className="text-neon-cyan text-lg" data-testid="cps-score">CLICKS: {clicks}</span>
        <span className="text-neon-yellow text-lg">⏱ {time}s</span>
      </div>
      {!running ? (
        <div className="text-center">
          {over && <p className="font-display font-black text-3xl text-neon-lime uppercase mb-3" data-testid="cps-result">{(clicks / 5).toFixed(1)} CPS · {clicks} clicks</p>}
          <Button onClick={start} data-testid="cps-start" className="bg-neon-cyan text-black rounded-none font-bold uppercase h-12 px-8">
            <Play className="w-4 h-4 mr-2 fill-black" /> {over ? "Try Again" : "Start (5s)"}
          </Button>
        </div>
      ) : (
        <button onClick={() => setClicks((c) => c + 1)} data-testid="cps-click"
          className="w-64 h-64 rounded-full bg-neon-pink text-black font-display font-black text-2xl uppercase active:scale-95 transition-transform"
          style={{ boxShadow: "0 0 40px #FF003C" }}>
          CLICK!
        </button>
      )}
      <p className="text-zinc-500 text-xs font-mono mt-4">Click as many times as you can in 5 seconds!</p>
    </div>
  );
}
